import { createApp } from 'vue'
import { createStore } from 'vuex'

import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_AXIOS_URL;

axios.defaults.headers.common = {
    Authorization: `Bearer ${localStorage.getItem("broker_token")}`,
};

import router from '../router'
import headers from './defaultHeaders'
import activeColumns from './defaultActives'
import noZeroData from './defaultnoZeroData'


export default createStore({
    state: {

        broker: {},
        params: {},

        activeColumns: activeColumns,
        noZeroData: noZeroData,
        headers: headers,

        isLoged: false,

        sortBy: '',
        filtreTable: '',

        loading: true,
        rgpd: true,



        assures: [],

        coBrokers: [],
        grBrokers: [],

        cotisationsCol: [],
        cotisationsInd: [],
        prestation: [],
        mainInfo: [],
        appel: [],
        docs: [],
        courtieDocs: [],

        translate: [],

        extractions: [],

        extractionDate: {
            startDate: '',
            endDate: '',
            prestaCal: ''
        },
        extractionAssureur: [],


        tempExtractionLink: false,
        tempExtractionCount: 0,
        tempExtractionLoading: false,
        tempExtractionDown: false,

        spa: 's',
        er: {
            name: 'Contrats en cours',
            status: 'e',
            active: true
        },
        login: {
            status: true,
            init: false,
            errorMesage: ''
        },



        holdingsData: {}
    },
    mutations: {

    },
    getters: {
        mainInfo: state => {
            return state.mainInfo;
        },

        translate: state => {
            return state.params.translate;
        },


        broker: state => {
            return state.broker
        },
        coBrokers: state => {
            return state.coBrokers
        },
        grBrokers: state => {
            return state.grBrokers
        },





        activeColumns: state => {
            return state.activeColumns
        },
        headers: state => {
            return state.headers
        },

        loginInfo: state => {
            return state.login
        },
        noZeroData: state => {
            return state.noZeroData
        },
        cotisationsCol: state => {
            return state.cotisationsCol
        },
        cotisationsInd: state => {
            return state.cotisationsInd
        }
    },
    actions: {
        isLoged() {
            localStorage.clear();
            localStorage.isLoged = false
            axios.post('isLoged').then((r) => {
                localStorage.isLoged = r.data.status
                if (r.data.status) router.push('/')
            })
        },
        setRgpd() {
            axios.post('setRgpd').then((r) => {
                this.state.rgpd = true
            })
        },
        async getCourtier() {
            this.state.loading = true

            await axios.get('data/params').then(r => {

                if (r.status === 200) {
                    this.state.params = r.data
                }

            })

            await axios.get('data/main').then(r => {

                if (r.status === 200) {
                    this.state.mainInfo = r.data
                }

            })

            this.state.loading = false

            // return

            axios.get('data/broker').then((r) => {
                localStorage.isLoged = true
                if (r.status === 200) {
                    localStorage.isLoged = true
                    this.state.rgpd = r.data.rgpd;

                    if (r.data.noZeroData) this.state.noZeroData = r.data.noZeroData
                    if (r.data.activeColumns) this.state.activeColumns = r.data.activeColumns

                    this.state.broker = r.data.broker
                    this.state.coBrokers = r.data.coBrokers
                    this.state.grBrokers = r.data.grBrokers
                } else {
                    localStorage.clear();
                    localStorage.isLoged = false
                        // window.location.href = '/login'
                }
            }).catch((error) => {
                console.log(error);
                alert(error)
            })
        },
        getMainInfo() {
            axios.post('getMainInfo').then((r) => {
                this.state.mainInfo = r.data
            })
        },
        getDocs() {
            axios.post('getDocs').then((r) => {
                this.state.docs = r.data
            })
        },
        getCourtierDocs() {
            this.state.courtieDocs = new Array()
            axios.post('getCourtierDocs').then((r) => {
                if (r.data.status) this.state.courtieDocs = r.data.courtieDocs
                setTimeout(() => {
                    this.state.loading = false
                }, 0);
            })
        },
        getCotisation() {
            axios.post('getCotisation').then((r) => {
                this.state.cotisationsCol = r.data
            })
        },
        getCotisationInd() {
            axios.post('getCotisationInd').then((r) => {
                this.state.cotisationsInd = r.data
            })
        },
        getPrestation() {
            axios.post('getPrestation').then((r) => {
                this.state.prestation = r.data
            })
        },
        getPrestation() {
            axios.post('getPrestation').then((r) => {
                this.state.prestation = r.data
            })
        },
        getTranslation() {
            axios.post('getTranslation').then((r) => {
                this.state.translate = r.data
            })
        },
        getExtraction() {
            axios.post('getExtraction').then((r) => {
                this.state.extractions = r.data
            })
        },
        saveColumns() {
            axios.post('saveColumns', {
                headers: this.state.activeColumns,
                noZeroData: this.state.noZeroData
            }).then((r) => {

            })
        },
        prepareExcelFile({ commit }, data) {

            if (!!data.type === false) {
                return
            }

            // if(data.list.length === 0){
            this.state.tempExtractionLoading = false
            this.state.tempExtractionLink = false
                // this.state.tempExtractionCount = 0
                //   return
                // }
            this.state.tempExtractionLink = false
            if (data.count === 0) this.state.tempExtractionLoading = true
            axios.post('extraction/' + data.type, {
                list: data.list,
                count: data.count,
                spa: this.state.spa,
                er: this.state.er.status,
                date: this.state.extractionDate,
                extractionAssureur: this.state.extractionAssureur
            }).then((r) => {
                this.state.tempExtractionCount = r.data.count
                if (r.data.status === true) {
                    this.state.tempExtractionLoading = false
                    this.state.tempExtractionLink = r.data.link
                    this.state.tempExtractionDown = r.data.down
                }
            })
        },
        createUser({ commit }, data) {
            axios.post('createUser',
                data
            ).then((r) => {
                console.log(r.data)
                this.state.login = r.data
            })
        },
        lostPassword({ commit }, data) {
            axios.post('lostPassword',
                data
            ).then((r) => {
                this.state.login = r.data
            })
        },
        createPassword({ commit }, data) {
            console.log(data);
            axios.post('createPassword',
                data
            ).then((r) => {
                if (r.data.status === true) window.location.href = '/'
                this.state.login = r.data
            })
        },

        logout({ commit }) {
            axios.post('logout').then((r) => {
                if (r.data.status == true) {
                    localStorage.isLoged = false
                    this.state.isLoged = false
                    window.location.href = '/'
                        // router.push('/login')
                }
            })
        },
        checkHash({ commit }, data) {
            axios.post('checkHash', data).then((r) => {
                this.state.login = r.data
            })
        }
    }
})